import { TicketingCollaboratorTypes } from 'containers/Ticketing/Collaborators/types';
import { REQUESTER_REDIRECT_SOURCE_SEARCH_PARAM } from 'containers/Ticketing/RequesterPortal/constants';

export type BuildTicketingRedirectUrlParams = {
  isAgent: boolean;
  isBoardMember: boolean;
  ticketId: string;
  threadId?: string | null;
  source?: string | null;
  collaboratorType?: TicketingCollaboratorTypes | null;
  tab?: string | null;
  type?: string | null;
};

/**
 * return either internal or requester portal redirect url
 * @param isAgent - whether the user is an agent
 * @param isBoardMember - whether the user is a board member
 * @param ticketId - the id of the ticket
 * @param threadId - the id of the thread (optional)
 * @param source - the source of the redirect (optional)
 * @param tab - matter-detail deep-link tab (optional, forwarded as `?tab=`)
 * @param type - matter-detail deep-link type (optional, forwarded as `?type=`)
 * @returns the redirect url
 */
export const buildTicketingRedirectUrl = ({
  isAgent,
  isBoardMember,
  collaboratorType,
  ticketId,
  threadId,
  source,
  tab,
  type,
}: BuildTicketingRedirectUrlParams) => {
  const paths = ['app', 'ticketing'];
  const isEditor = collaboratorType === TicketingCollaboratorTypes.EDITOR;

  if ((isAgent && isBoardMember) || isEditor) {
    // Agent: /app/ticketing or /app/ticketing/tickets/{ticketId}
    if (ticketId) {
      paths.push('tickets', ticketId);
    }
  } else {
    // Non-agent: /app/ticketing/portal or /app/ticketing/portal/{ticketId}
    paths.push('portal');
    if (ticketId) {
      paths.push(ticketId);
    }
  }

  // Add thread if provided
  if (threadId) {
    paths.push('threads', threadId);
  }

  const pathname = `/${paths.join('/')}`;

  const params = new URLSearchParams();
  if (source && !isAgent) {
    params.set(REQUESTER_REDIRECT_SOURCE_SEARCH_PARAM, source);
  }
  if (tab) params.set('tab', tab);
  if (type) params.set('type', type);

  const queryString = params.toString();
  return queryString ? `${pathname}?${params.toString()}` : pathname;
};
